import React, { useEffect, useState, useRef, lazy } from 'react';
import { CheckCircleIcon, XIcon } from 'lucide-react';
interface Purchase {
  name: string;
  city: string;
  state: string;
  timeAgo: string;
  price: string;
}
export function RecentPurchases() {
  const [currentPurchase, setCurrentPurchase] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const [isClient, setIsClient] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout>();
  const intervalRef = useRef<NodeJS.Timeout>();
  const purchases: Purchase[] = [{
    name: 'María G.',
    city: 'Ciudad de México',
    state: 'CDMX',
    timeAgo: 'hace 4 min',
    price: '$190'
  }, {
    name: 'Ana R.',
    city: 'Guadalajara',
    state: 'Jalisco',
    timeAgo: 'hace 8 min',
    price: '$190'
  }, {
    name: 'Lupita H.',
    city: 'Monterrey',
    state: 'Nuevo León',
    timeAgo: 'hace 12 min',
    price: '$190'
  }, {
    name: 'Carmen S.',
    city: 'Puebla',
    state: 'Puebla',
    timeAgo: 'hace 15 min',
    price: '$190'
  }, {
    name: 'Rosa M.',
    city: 'Tijuana',
    state: 'Baja California',
    timeAgo: 'hace 19 min',
    price: '$190'
  }, {
    name: 'Patricia L.',
    city: 'León',
    state: 'Guanajuato',
    timeAgo: 'hace 23 min',
    price: '$190'
  }, {
    name: 'Sofía V.',
    city: 'Querétaro',
    state: 'Querétaro',
    timeAgo: 'hace 27 min',
    price: '$190'
  }, {
    name: 'Diana M.',
    city: 'Mérida',
    state: 'Yucatán',
    timeAgo: 'hace 31 min',
    price: '$190'
  }];
  // Solo ejecutar en cliente (evita SSR issues)
  useEffect(() => {
    setIsClient(true);
  }, []);
  useEffect(() => {
    if (!isClient) return;
    // Primera aparición después de 8 segundos
    const initialTimeout = setTimeout(() => {
      if (!isDismissed) {
        setIsVisible(true);
        // Auto-hide después de 6 segundos
        timeoutRef.current = setTimeout(() => {
          setIsVisible(false);
        }, 6000);
      }
    }, 8000);
    // Aparecer cada 25 segundos (no hostigante)
    intervalRef.current = setInterval(() => {
      if (!isDismissed) {
        setIsVisible(false);
        setTimeout(() => {
          setCurrentPurchase(prev => (prev + 1) % purchases.length);
          setIsVisible(true);
          // Auto-hide después de 6 segundos
          timeoutRef.current = setTimeout(() => {
            setIsVisible(false);
          }, 6000);
        }, 500);
      }
    }, 25000);
    return () => {
      clearTimeout(initialTimeout);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [isClient, isDismissed, purchases.length]);
  const handleDismiss = () => {
    setIsVisible(false);
    setIsDismissed(true);
  };
  // No renderizar en servidor o si está cerrado
  if (!isClient || isDismissed) return null;
  const purchase = purchases[currentPurchase];
  return <div className={`fixed bottom-6 left-4 sm:left-6 z-50 transition-all duration-500 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`} data-id="element-472">
      <div className="bg-white rounded-lg shadow-2xl border border-accent-success/20 overflow-hidden max-w-sm backdrop-blur-sm" data-id="element-473">
        {/* Green verification bar */}
        <div className="h-0.5 bg-gradient-to-r from-accent-success to-accent-success/70" data-id="element-474"></div>

        <div className="p-3" data-id="element-475">
          <div className="flex items-center gap-2.5" data-id="element-476">
            {/* Product thumbnail - OPTIMIZADA CON LAZY LOADING */}
            <div className="flex-shrink-0 w-12 h-12 rounded-lg overflow-hidden bg-gradient-to-br from-almond-milk to-soft-beige shadow-soft" data-id="element-477">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/m4yThtScr4RZyGecczd1NM/Untitled_design_%2862%29.png" alt="Guía TikTok Shop" width="48" height="48" loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-478" />
            </div>

            {/* Content */}
            <div className="flex-1 min-w-0" data-id="element-479">
              {/* Header with verified badge */}
              <div className="flex items-center gap-1 mb-0.5" data-id="element-480">
                <CheckCircleIcon className="w-3.5 h-3.5 text-accent-success flex-shrink-0" data-id="element-481" />
                <span className="text-[10px] font-bold text-accent-success uppercase tracking-wide" data-id="element-482">
                  Compra Verificada
                </span>
              </div>

              {/* Customer info */}
              <p className="text-sm font-bold text-deep-cocoa leading-tight" data-id="element-483">
                {purchase.name} • {purchase.city}
              </p>

              {/* Product and price */}
              <div className="flex items-center gap-1.5 text-xs text-deep-cocoa/70 mt-0.5" data-id="element-484">
                <span className="font-bold text-cta-primary" data-id="element-485">
                  {purchase.price}
                </span>
                <span className="text-deep-cocoa/40" data-id="element-486">•</span>
                <span className="text-[10px]" data-id="element-487">{purchase.timeAgo}</span>
              </div>
            </div>

            {/* Close button */}
            <button onClick={handleDismiss} className="flex-shrink-0 w-5 h-5 flex items-center justify-center rounded-full hover:bg-deep-cocoa/5 transition-colors" aria-label="Cerrar notificación" data-id="element-488">
              <XIcon className="w-3.5 h-3.5 text-deep-cocoa/40" data-id="element-489" />
            </button>
          </div>
        </div>
      </div>
    </div>;
}